import { cn } from '~/utils/misc.tsx'
import { formatPrice, roundSessionValue } from '~/utils/strings.ts'

export const Price = ({
  amount,
  currency,
  className,
  rounded = false,
  isSessionValue = false,
}: {
  amount: number
  currency: String
  className?: string
  rounded?: boolean
  isSessionValue?: boolean
}) => {
  if (rounded && currency !== 'EUR') {
    amount = Math.ceil(amount)
  }

  if (isSessionValue) {
    amount = roundSessionValue(amount)
  }

  return (
    <span className={cn('flex gap-1 whitespace-normal pl-2', className)}>
      {/* Schema.org markup for price */}
      <div itemProp="price" content={amount.toString()}>
        {formatPrice(amount)}
      </div>
      <div itemProp="priceCurrency" content={currency.toString()}>
        {currency}
      </div>
    </span>
  )
}
